import React from "react";

function amountToWords(num) {
  if (isNaN(num) || num === "" || num === null) return "";

  const a = [
    "", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten",
    "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
    "seventeen", "eighteen", "nineteen"
  ];

  const b = [
    "", "", "twenty", "thirty", "forty", "fifty",
    "sixty", "seventy", "eighty", "ninety"
  ];

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return a[Math.floor(n / 100)] + " hundred" + (n % 100 ? " " + inWords(n % 100) : "");
    if (n < 100000)
      return inWords(Math.floor(n / 1000)) + " thousand" + (n % 1000 ? " " + inWords(n % 1000) : "");
    if (n < 10000000)
      return inWords(Math.floor(n / 100000)) + " lakh" + (n % 100000 ? " " + inWords(n % 100000) : "");
    return inWords(Math.floor(n / 10000000)) + " crore" + (n % 10000000 ? " " + inWords(n % 10000000) : "");
  }

  const parts = Number(num).toFixed(2).split(".");
  const rupees = parseInt(parts[0]);
  const paise = parseInt(parts[1]);

  let words = "";

  if (rupees > 0) words += inWords(rupees) + " rupees";
  if (paise > 0) words += (words ? " and " : "") + inWords(paise) + " paise";

  return words || "zero rupees";
}

const AmountToWords = ({ amount }) => {
  return (
    <div className="text-h3 fcap text-r">
      {amountToWords(amount)}
    </div>
  );
};

export default AmountToWords;
